import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './file-picker.styl'
import config from 'config'

export default class FilePicker extends Component {
  static propTypes = {
    supportedTypes: PropTypes.array,
    change: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired
  }
  static defaultProps = {
    supportedTypes: [
      'image/jpeg',
      'image/png',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'application/pdf',
      'video/mp4'
    ]
  }

  state = {
    selectedFile: null,
    fileSize: 0
  }

  fileSelection = e => {
    const file = e.target.files[0]

    this.setState({
      selectedFile: file,
      fileSize: file.size
    })
    this.props.change(this.props.name, file)
  }

  handleIsFileValid = () => {
    return this.state.fileSize > config.fileSizeLimit
  }

  render() {
    const { supportedTypes } = this.props
    const { selectedFile } = this.state

    return (
      <div>
      <div className={styles.filePicker}>
        <div className={styles.block}>
          {!selectedFile &&
            <div>
              <span className={`ico ico--add ${styles.ico}`} />
              <p className={styles.label}>
                <FormattedMessage
                  id="label.add_file"
                  defaultMessage="Add file"
                />
              </p>
            </div>}
          {selectedFile &&
            <div>
              <span className={`ico ico--file-other ${styles.ico}`} />
              <p className={styles.label}>
                {selectedFile.name}
              </p>
            </div>}
        </div>

       <input
          type="file"
          className={styles.file}
          onChange={this.fileSelection}
          accept={supportedTypes}
        />
      </div>
    <br />
    {this.handleIsFileValid() && (
      <span style={{ color: '#B71C1C', paddingRight: '30px', fontSize: '14px' }}>
                <FormattedMessage
                  id="errors.file_is_too_large"
                  defaultMessage="File is too large."
                />
              </span>)}
      </div>
    )
  }
}
